import { VISIBLE_USERS_FETCH_SUCCESS } from 'VisibleUsers/constants'

export const visibleUsersFetchSuccess = payload => ({ payload, type: VISIBLE_USERS_FETCH_SUCCESS })
